import { authApi, modulesApi } from '@app/services'
import { api as eventApi } from '@app/services/auto-generated/event'
import { store } from '@app/store'
import { defer } from '@lib/router'

const eventLoader = async ({ params }) => {
  const event = await promise(params.event_id)
  const { data: totalJoins } = await promiseGetTotalJoins()
  const { data: modules } = await promiseModules()
  return defer({ event, modules, totalJoins })
}

const promise = async (eventId: string) => {
  const { data: event } = await store.dispatch(
    eventApi.endpoints.eventGetEventById.initiate({ eventId }),
  )
  if (!event) {
    return null
  }
  const { data: currentEvent } = await store.dispatch(
    eventApi.endpoints.eventGetEventById.initiate({ eventId: event.event_id }),
  )
  if (!event?.is_live) {
    return event
  }

  const user = store.getState().auth.user
  if (!user) return

  // if not joined then join
  // const joined = Boolean(event.users?.find((elem) => elem.id === user.id))

  // if (!joined) {
  //   const data = await store.dispatch(
  //     eventApi.endpoints.eventJoinEvent.initiate({ eventId, exit: true }),
  //   )
  //   const err = data?.error
  //   if (err && isErrorResponse(err)) {
  //     if (err.data.detail.error_code === 'EXC_EVENT_USER_NOT_ALLOWED_TO_JOIN') {
  //       return {
  //         kicked: true,
  //       }
  //     }
  //   }
  // }

  return currentEvent
}
const promiseModules = async () => {
  const response = store.dispatch(
    modulesApi.endpoints.modulesGetUserModules.initiate(undefined, { forceRefetch: true }),
  )

  return response
}
const promiseGetTotalJoins = async () => {
  const response = store.dispatch(
    eventApi.endpoints.eventGetTotalEventJoins.initiate(undefined, { forceRefetch: true }),
  )

  return response
}

export default eventLoader
